import { render, staticRenderFns } from "./AssessmentClientCards.vue?vue&type=template&id=9250c8a0&"
import script from "./AssessmentClientCards.vue?vue&type=script&lang=js&"
export * from "./AssessmentClientCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports